const test_enabled = process.env.REACT_APP_TEST_ENABLED?.toLocaleLowerCase();
const test_mode = test_enabled === "1" || test_enabled === "y";

export default {
  is_test_server: test_mode && window.location.href.includes(`test-goono`),
  test_mode,
  unit_price: 12000,
  vat_rate: 1.1,
};
